import { Component, Input, HostBinding, inject } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { MEASURES_ICONS } from '@bepatient/core';

@Component({
  selector: 'bepatient-dynamic-icon',
  templateUrl: './dynamic-icon.component.html',
  styleUrls: ['./dynamic-icon.component.scss'],
  standalone: false
})
export class DynamicIconComponent {
  private sanitizer = inject(DomSanitizer);

  private _icon: string;
  public isBepatientIcon: boolean;

  @Input() color: string;
  @Input() size: number;

  @HostBinding('attr.style')
  get valueAsStyle(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`--icon-size: ${this.size}`);
  }

  @Input() set iconName(icon) {
    this.isBepatientIcon = Object.values(MEASURES_ICONS).includes(icon);
    this._icon = this.isBepatientIcon
      ? `/common/assets/images/${icon}.svg`
      : !icon
      ? 'help'
      : icon;
  }

  get iconName() {
    return this._icon;
  }
}
